import { type RouteLocation, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';

const BriefOverview = (): unknown => {
    return import(/* webpackPrefetch: true */ './brief-overview-page.vue');
};

export const briefOverviewRoute: RouteRecordRaw = {
    ...ROUTE_DATA.BRIEF_OVERVIEW_PAGE,
    components: {
        main: BriefOverview
    },
    props: {
        main(route: RouteLocation): { briefId?: number } {
            return { briefId: routerHelper.parseParamToInt(route.params.id as string) };
        }
    }
};
